"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperProperties = void 0;
var cookie_1 = require("./cookie");
var SuperProperties = /** @class */ (function () {
    function SuperProperties(sdkConfig) {
        this.sdkConfig = sdkConfig;
        this.LOGSPOT_PROPS = "lgspt_p";
        this.expiryDays = 30;
        var cookie = (0, cookie_1.getCookie)(this.LOGSPOT_PROPS);
        var decoded = cookie ? JSON.parse(this.UnicodeDecodeB64(cookie)) : {};
        this.properties = decoded;
    }
    SuperProperties.prototype.register = function (newProps, days) {
        this.properties = __assign(__assign({}, this.properties), newProps);
        if (typeof days !== "undefined") {
            this.expiryDays = days;
        }
        this._save();
    };
    SuperProperties.prototype.unregister = function (property) {
        delete this.properties[property];
        this._save();
    };
    SuperProperties.prototype.clear = function () {
        this.properties = {};
        (0, cookie_1.eraseCookie)(this.LOGSPOT_PROPS);
    };
    SuperProperties.prototype.getProperties = function () {
        return this.properties;
    };
    SuperProperties.prototype._save = function () {
        var _a;
        if (this.sdkConfig.cookiesDisabled) {
            return;
        }
        (0, cookie_1.setCookie)({
            name: this.LOGSPOT_PROPS,
            value: this.b64EncodeUnicode(JSON.stringify(this.properties)),
            expiresInSeconds: this.expiryDays * cookie_1.ONE_DAY_IN_SECONDS,
            domain: (_a = this.sdkConfig.cookieDomain) !== null && _a !== void 0 ? _a : null,
        });
    };
    SuperProperties.prototype.b64EncodeUnicode = function (str) {
        return btoa(encodeURIComponent(str));
    };
    SuperProperties.prototype.UnicodeDecodeB64 = function (str) {
        return decodeURIComponent(atob(str));
    };
    return SuperProperties;
}());
exports.SuperProperties = SuperProperties;
